import React from 'react';
import propTypes from 'prop-types';
import './style.css';
import * as routeHelper from '../../../../helpers/route';
import { getType } from '../../../../helpers/poi';
import { FAILURE } from '../../../../utils/status';
import { formatDateUseZone8 } from '../../../../utils/formatDate';

export default class FullTrip extends React.Component {
  render(){
    let tripInfo = this.getTripInfo();
    let simpleList = this.getSimpleList();
    return (
      <section className='full-trip'>
        <div className='trip-info'>
          <h3>行程概况</h3>
          {
            tripInfo.map((item, index)=>{
              return <TripInfo list={item.list} key={index}/>;
            })
          }
        </div>
        <div className="simple-trip-list">
          <ul>
            {
              simpleList.map((item,index)=>{
                return <SimpleItem {...item} key={index} handleClickDayItem={this.handleClickDayItem}/>;
              })
            }
          </ul>
        </div>
      </section>
    );
  }


  getTripInfo = ()=>{
    let {trip, fullTripRoute, fullTripRouteStatus} = this.props;
  
    let distance = '--';
    let oil = '--';
    if (fullTripRoute && fullTripRouteStatus !== FAILURE) {
      distance = routeHelper.caculateDistance(fullTripRoute);
      distance = routeHelper.formatDistance(distance);
      oil = routeHelper.caculateOils(fullTripRoute);
      oil = routeHelper.formatOils(oil);
    }

    let poiTypeCount = this.getPoiType();
    let tripInfo = [{
      index: 1,
      list: [{
        title: '天数',
        icon: 'icon icon-index-day',
        data: trip.trip_days
      },{
        title: '国家',
        icon: 'icon icon-index-region',
        data: poiTypeCount.region || Object.keys(trip.region_info_maps).length
      },{
        title: '城市',
        icon: 'icon icon-index-city',
        data: Object.keys(trip.city_info_maps).length
      },{
        title: '里程(Km)',
        icon: 'icon icon-index-meter',
        data: distance
      },{
        title: '耗油(L)',
        icon: 'icon icon-index-oil',
        data: oil
      }]
    },
    {
      index: 2,
      list:[{
        title: '景点',
        icon: 'icon icon-index-attraction',
        data: poiTypeCount.attraction
      },{
        title: '酒店',
        icon: 'icon icon-index-hotel',
        data: poiTypeCount.hotel
      },{
        title: '美食',
        icon: 'icon icon-index-food',
        data: poiTypeCount.food
      },{
        title: '购物',
        icon: 'icon icon-index-shopping',
        data: poiTypeCount.shopping
      },{
        title: '娱乐',
        icon: 'icon icon-index-entertainment',
        data: poiTypeCount.entertainment
      }]
    }
    ];
    return tripInfo;
  } 

  getPoiType = ()=>{
    let { trip } = this.props;
    let poiTypeCount = {
      region: 0,
      attraction: 0,
      food: 0,
      hotel: 0,
      shopping: 0,
      entertainment: 0
    };
    let _region = {};
    trip.poi_list.forEach(item => {
      if(item.pois){
        item.pois.forEach((v)=>{
          //计算类型
          let type = getType(v.poi_uid);
          poiTypeCount[type] = poiTypeCount[type] + 1;
        });
      }

      //计算国家
      if(item.city_list){
        item.city_list.forEach((city)=>{ 
          let cityRegion = trip.city_info_maps[city.city_id].region;
          if(cityRegion && !_region[cityRegion]){
            _region[cityRegion] = true;
            poiTypeCount.region = poiTypeCount.region + 1;
          }
        });
      }
    });
    return poiTypeCount;
  }

  getSimpleList = ()=>{
    let { trip } = this.props;
    let { poi_uid_map, city_info_maps } = trip;
    let simpleList = trip.poi_list.map((item,index) => {
      let cityStr = item.city_list.map((v)=>{
        return city_info_maps[v.city_id].cn_name;
      }).join('-');
      let poiStr = item.pois.map((v)=>{
        return poi_uid_map[v.poi_uid].info.cn_name;
      }).join('<span>&gt;</span>') || '<span>今天还没安排游玩地点</span>';

      let date = item.date ? formatDateUseZone8(item.date * 1000, 'MM月dd日') : '';

      return {
        index: index + 1,
        date,
        cityStr,
        poiStr
      };
    });

    return simpleList;
  }

  handleClickDayItem = (day)=>{
    let { selectDay } = this.props;
    selectDay(day);
    document.querySelector('.trip-body').scrollTop = 0;
  }

}
FullTrip.propTypes = {
  trip: propTypes.object.isRequired,
  fullTripRoute: propTypes.object,
  fullTripRouteStatus: propTypes.string
};




function TripInfo(props) {
  let { list } = props;
  return(
    <ul className="trip-info-item-list">
      {
        list && list.map((item, index)=>{
          return <TripInfoItem {...item} key={index} />;
        })
      }
    </ul>
  );
}

function TripInfoItem(props) {
  let {data, icon, title} = props;
  return (
    <li className='trip-info-item'>
      <i className={icon} />
      <p className='trip-info-title'>{title}</p>
      <p>{data}</p>
    </li>
  );
}




function SimpleItem(props) {
  let {index, date, cityStr, poiStr ,handleClickDayItem}= props;
  return(
    <li className="simple-list-item" 
      onClick={()=>{
        handleClickDayItem(index);
      }}>
      <div className="inner">
        <h4 className="title">
          第{index}天 
          <span className="time">{date}</span>
          <span className="city">{cityStr}</span>
        </h4>
        <p className="desc" dangerouslySetInnerHTML={{__html: poiStr}}></p>
      </div>
    </li>
  );
}






// WEBPACK FOOTER //
// ./src/pages/trip/Trip/FullTrip2/index.js